import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './styles/globals.css'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
    <BrowserRouter>
      <App />
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1A2E45',
            color: '#E8E0D0',
            border: '1px solid #2563eb',
          },
          success: {
            iconTheme: {
              primary: '#4CAF7D',
              secondary: '#1A2E45',
            },
          },
          error: {
            iconTheme: {
              primary: '#C94C4C',
              secondary: '#1A2E45',
            },
          },
        }}
      />
    </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)